import React, {Fragment} from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {AddressFormatter} from "../../../utils/formatters";
import StyleInjector from "../../layout/StyleInjector";

// https://stackoverflow.com/questions/35969656/how-can-i-generate-the-opposite-color-according-to-current-color

function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
}

function invertColor(hex, bw) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
            ? '#000000'
            : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r) + padZero(g) + padZero(b);
}

class ShopList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        if (Array.isArray(props.view)) {
            props.view.push("color");
        } else if (props.view instanceof Object) {
            props.view.color = "";
        } else {
            props.view = ["color"];
        }
        return (
            <Fragment>
                {((this.state || {}).rows || []).map((row, idx) => {
                    if (row.color) {
                        let hex = row.color;
                        if (hex.indexOf('#') === 0) {
                            hex = hex.slice(1);
                        }
                        // convert 3-digit hex to 6-digits.
                        if (hex.length === 3) {
                            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                        }
                        if (hex.length !== 6) {
                            return null;
                        }
                        var r = parseInt(hex.slice(0, 2), 16),
                            g = parseInt(hex.slice(2, 4), 16),
                            b = parseInt(hex.slice(4, 6), 16);
                        return <StyleInjector key={idx} style={"td.p-editable-column.p-cell-editing {background-color: rgba(" + r + "," + g + "," + b + ", .1)"/* + "; color: " + invertColor(row.color)*/ + "}"} id={"shop-" + row.id} />;
                    }
                    return null;
                })}
                <SelectorGrid
                    ref={(el) => this.list = el}
                    gridid={this.props.gridid !== undefined ? this.props.gridid : "ShopList"}
                    {...props}
                    columns={{
                        "name": {header: 'Név', width: 6, sortable, filterable},
                        "address": {header: 'Cím', width: 6, renderer: AddressFormatter},
                    }}
                    onLoadCompleted={(response) => {
                        this.setState({rows: response.rows});
                    }}
                    rowClassName={(rowData) => {
                        return {["shop-" + rowData.id]: true};
                    }}
                    orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                    selection={selection}
                    onSelectionChange={(selection) => this.props.loadForm(selection.value)}
                />
            </Fragment>
        );
    }
}

export default ShopList;
